/**
 * Most worn — best ROI item, cost-per-wear hero card.
 */
import { store } from '../store.ts';
import { formatINR, CATEGORY_DISPLAY } from '../types.ts';
import type { ClothingItem } from '../types.ts';

export class AlmariMostWorn extends HTMLElement {
  #shadow = this.attachShadow({ mode: 'open' });
  #unsub?: () => void;

  connectedCallback(): void {
    this.#unsub = store.subscribe((s) => {
      if (s.summary?.insights?.most_worn) this.#render(s.summary.insights.most_worn);
      else this.#shadow.innerHTML = '<style>:host{display:none;}</style>';
    });
  }
  disconnectedCallback(): void { this.#unsub?.(); }

  #render(item: ClothingItem): void {
    this.#shadow.innerHTML = /* html */ `
<style>
:host {
  display: block;
  background: var(--paper-card);
  border: 1px solid var(--rule);
  border-radius: 8px;
  padding: 24px 22px 26px;
  position: relative;
  overflow: hidden;
}
.label {
  font-family: var(--mono);
  font-size: 10px;
  letter-spacing: 0.4em;
  text-transform: uppercase;
  color: var(--leaf);
}
.tag {
  font-family: var(--display);
  font-style: italic;
  font-size: 14px;
  color: var(--ink-dim);
  margin-top: 2px;
}
.name {
  font-family: var(--display);
  font-size: clamp(28px, 8cqw, 38px);
  font-weight: 700;
  color: var(--ink);
  margin-top: 14px;
  letter-spacing: -0.015em;
  line-height: 1.05;
}
.brand {
  font-family: var(--display);
  font-size: 17px;
  font-style: italic;
  color: var(--brass-dim);
  margin-top: 4px;
}
.cpw {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin-top: 22px;
  padding-top: 16px;
  border-top: 1px dashed var(--rule);
}
.cpw-num {
  font-family: var(--display);
  font-size: 48px;
  font-weight: 700;
  color: var(--leaf);
  letter-spacing: -0.025em;
  line-height: 1;
  font-feature-settings: "tnum" 1;
}
.cpw-cap {
  font-family: var(--mono);
  font-size: 10px;
  color: var(--ink-faint);
  letter-spacing: 0.3em;
  text-transform: uppercase;
}
.meta {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 18px;
}
.meta-cell {
  display: grid;
  gap: 4px;
}
.meta-lbl {
  font-family: var(--mono);
  font-size: 9px;
  letter-spacing: 0.25em;
  text-transform: uppercase;
  color: var(--ink-faint);
}
.meta-val {
  font-family: var(--display);
  font-size: 16px;
  font-weight: 700;
  color: var(--ink);
  font-feature-settings: "tnum" 1;
}
</style>
<div class="label">Best ROI · most worn</div>
<div class="tag">"jiska ek-ek paisa wasool hai"</div>
<div class="name">${escape(item.name)}</div>
<div class="brand">${escape(item.brand)} · ${CATEGORY_DISPLAY[item.category] ?? item.category}</div>
<div class="cpw">
  <span class="cpw-num">${formatINR(item.cost_per_wear)}</span>
  <span class="cpw-cap">per wear</span>
</div>
<div class="meta">
  <div class="meta-cell">
    <div class="meta-lbl">wear count</div>
    <div class="meta-val">${item.wear_count}</div>
  </div>
  <div class="meta-cell">
    <div class="meta-lbl">paid</div>
    <div class="meta-val">${formatINR(item.value_inr)}</div>
  </div>
  <div class="meta-cell">
    <div class="meta-lbl">color</div>
    <div class="meta-val" style="font-size:13px;text-transform:lowercase;">${escape(item.color)}</div>
  </div>
</div>
`;
  }
}

function escape(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] ?? c));
}

customElements.define('almari-most-worn', AlmariMostWorn);
